import { render, staticRenderFns } from "./AngleDownIcon.vue?vue&type=template&id=207197a4&"
import script from "./AngleDownIcon.vue?vue&type=script&lang=js&"
export * from "./AngleDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports